import { cancel, createPromise, Waiter, WaiterWith } from "common/promises";
import { constrain, lerp } from "./math";
export class PixiContext {
    constructor(app) {
        this.canceler = new cancel.Canceler();
        this.app = app;
    }
    dispose() {
        this.canceler.cancel();
    }
    get ticker() {
        return this.app.ticker;
    }
    async delay(ms) {
        if (this.canceler.canceled) {
            return;
        }
        const ticker = this.ticker;
        const context = {
            remainMS: ms,
        };
        const { promise, resolve } = await createPromise();
        const canceler = this.canceler;
        if (canceler.canceled) {
            return;
        }
        function tick() {
            const ms = ticker.deltaMS;
            context.remainMS -= ms;
            if (context.remainMS < 0) {
                ticker.remove(tick);
                resolve();
            }
            if (canceler.canceled) {
                resolve();
            }
        }
        ticker.add(tick);
        return promise;
    }
    async animate({ start, destination, durationMS, setter }) {
        if (this.canceler.canceled) {
            return;
        }
        const ticker = this.ticker;
        const context = {
            cursor: 0,
        };
        const errorHappen = new WaiterWith();
        function tick() {
            const ms = ticker.deltaMS;
            context.cursor += ms / durationMS;
            let value = lerp(start, destination, context.cursor);
            value = constrain({
                min: Math.min(start, destination),
                max: Math.max(start, destination),
                value,
            });
            try {
                setter(value, ms / durationMS);
            }
            catch (err) {
                errorHappen.trigger(err);
            }
        }
        setter(start, 0);
        ticker.add(tick);
        const result = await Promise.race([
            this.delay(durationMS),
            errorHappen.wait(),
        ]);
        ticker.remove(tick);
        setter(destination, 0);
        if (result) {
            throw result;
        }
    }
    async animateLoop(iter) {
        if (this.canceler.canceled) {
            return;
        }
        const ticker = this.ticker;
        const waiter = new Waiter();
        function tick() {
            const ms = ticker.deltaMS;
            if (!iter(ms)) {
                ticker.remove(tick);
                waiter.trigger();
            }
        }
        ticker.add(tick);
        await waiter.wait();
    }
    async fadeOut({ durationMS, sprite }) {
        await this.animate({
            start: 1,
            destination: 0,
            durationMS,
            setter: (value) => (sprite.alpha = value),
        });
    }
    async fadeIn({ durationMS, sprite }) {
        await this.animate({
            start: 0,
            destination: 1,
            durationMS,
            setter: (value) => (sprite.alpha = value),
        });
    }
}
//# sourceMappingURL=pixi.js.map